export default __webpack_public_path__ + "static/media/repair-icon.8c683c36.svg";